// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: 'https://192.168.1.13:7106/api'
  apiUrl: 'https://be-test-ubie.app.ubiecloud.com/api',

  apiRoot: 'https://be-test-ubie.app.ubiecloud.com/jwtapi',
  server: 'https://be-test-ubie.app.ubiecloud.com/',
  logRoot: 'http://localhost:1337/api',
  mqtt: {
    host: 'be-test.mqtt.ubiecloud.com', hostname: 'be-test.mqtt.ubiecloud.com',
    user: 'jYayfDaExt', pass: 'df1yRl0T5g7z', keepalive: 10, port: 8081, ssl: true, path: '', retain: false
  },
  configurations: {
    pagesConfig: 'pagesConfig'
  },
  calendar: ''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
